<app-navbar></app-navbar>

<main class="ai-booking-page-wrap">
  <div class="page-container container mx-auto">
    <div class="grid grid-cols-12 items-center min-h-[calc(100vh-140px)] py-10">
      
      <!-- Left Column: Showcase Info -->
      <div class="col-span-12 lg:col-span-7 px-4 mb-8 lg:mb-0">
        <div class="assistant-intro-card">
          <div class="intro-badge">
            <span class="material-symbols-outlined text-[18px]">smart_toy</span>
            <span>Next-Gen Healthcare AI</span>
          </div>

          <h1 class="intro-title">
            Meet <span class="highlight-text">Mily</span>,<br />
            Your MedEase Live Assistant
          </h1>

          <p class="intro-description">
            Ask health questions, find matching specialists, and book confirmed appointments with ease. Available on every page through the floating chat launcher.
          </p>

          <div class="features-list">
            <div class="feature-item">
              <div class="feature-icon">
                <span class="material-symbols-outlined">bolt</span>
              </div>
              <div class="feature-text">
                <h4>Instant Doctor Matching</h4>
                <p>Natural AI intent understanding for accurate specialty recommendations.</p>
              </div>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <span class="material-symbols-outlined">event_available</span>
              </div>
              <div class="feature-text">
                <h4>Live Slot Booking</h4>
                <p>Browse real-time open slots and reserve appointments in seconds.</p>
              </div>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <span class="material-symbols-outlined">verified_user</span>
              </div>
              <div class="feature-text">
                <h4>Available Across All Pages</h4>
                <p>Click the floating &ldquo;ASK Mily&rdquo; widget in the bottom-right corner from anywhere on MedEase.</p>
              </div>
            </div>
          </div>

          <div class="intro-cta-row">
            <button type="button" class="start-chat-btn" (click)="chatService.open()">
              <span class="material-symbols-outlined">chat</span>
              <span>Talk to Mily Now</span>
            </button>
            <a href="/doctors" class="browse-doctors-link">
              <span>Browse Doctors Directory</span>
              <span class="material-symbols-outlined text-[16px]">arrow_forward</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Right Column: Interactive Quick Card Preview -->
      <div class="col-span-12 lg:col-span-5 px-4 flex justify-center">
        <div class="ria-preview-hero-card">
          <div class="preview-hero-header">
            <div class="preview-avatar-wrap">
              <img src="/assets/images/ria-avatar.png" alt="Mily" class="preview-avatar-img" />
              <span class="preview-status-dot"></span>
            </div>
            <div>
              <h3 class="preview-title">Ask Mily</h3>
              <p class="preview-subtitle">Live Service Champion &bull; Online</p>
            </div>
          </div>

          <div class="preview-hero-body">
            <p class="preview-welcome-text">
              &ldquo;Hello! I&rsquo;m Mily. Click below or tap the floating chat widget on any page to get started instantly!&rdquo;
            </p>

            <div class="preview-menu-list">
              <button type="button" class="preview-menu-btn" (click)="chatService.open()">
                <span class="material-symbols-outlined text-[#45a6d1]">calendar_month</span>
                <span>Book an Appointment</span>
              </button>
              <button type="button" class="preview-menu-btn" (click)="chatService.open()">
                <span class="material-symbols-outlined text-[#45a6d1]">medical_services</span>
                <span>Browse Specialities</span>
              </button>
              <button type="button" class="preview-menu-btn" (click)="chatService.open()">
                <span class="material-symbols-outlined text-[#45a6d1]">person_search</span>
                <span>Find Doctors</span>
              </button>
              <button type="button" class="preview-menu-btn" (click)="chatService.open()">
                <span class="material-symbols-outlined text-[#45a6d1]">receipt_long</span>
                <span>Check My Bookings</span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</main>

<app-footer></app-footer>
